<template>
  <template v-if="view==='listar'">

    <button class="flex items-center px-2 py-1 text-white bg-green-500 rounded-md hover:bg-green-600 focus:outline-none"
        style="white-space: nowrap;"
        @click="$emit('updateValues', {'view': 'notificar_embargo'});$emit('data', data);"
    v-if="data.notificaciones">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="w-5 h-6 mr-1">
      <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
    </svg>

      Notificado
    </button>

    <button class="flex items-center px-2 py-1 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none"
        style="white-space: nowrap;"
        @click="$emit('updateValues', {'view': 'notificar_embargo'});$emit('data', data);"
        v-else>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
        <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5" />
      </svg>
      Notificar
    </button>

  </template>
</template>
<script>

export default {
  name: 'BotonNotificarEmbargoPersonaComponent',
  props: ['view', 'data'],
  emits: ['updateValues', 'data']
}
</script>